import { render, staticRenderFns } from "./global-message.vue?vue&type=template&id=03e2720e&scoped=true&"
import script from "./global-message.vue?vue&type=script&lang=js&"
export * from "./global-message.vue?vue&type=script&lang=js&"
import style0 from "./global-message.vue?vue&type=style&index=0&id=03e2720e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e2720e",
  null
  
)

export default component.exports